import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import {
  FormElement,
  FormList,
  FormListItem,
} from '../components/CommonFormComponents';
import * as UserFormElements from '../components/UserFormElements';
import fetchMg from '../utilities/fetchManager';
import { USER_ROLES, HEADER_CONSTANTS } from '../utilities/constants';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  isPrimaryCompanyRoleId,
  isTargetRoleId,
  isPartnerRoleId,
  isForemanRoleId,
} from '../utilities/roleUtility';
import {
  PreviewFormText,
  PreviewFormImage,
  PreviewFormTel,
  PreviewFormItemValue,
} from '../components/PreviewForm';
import { MasterPageHeader } from '../components/PageHeader';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';

/**
 * @description アカウント詳細・編集(詳細時)
 */
export class UserProfileDetail extends React.Component {
  constructor(props) {
    super(props);

    // タイトル名
    this.TITLE_NAME = 'アカウント詳細・編集';

    this.userId = LocalStorageService.getUserId();
    this.roleId = LocalStorageService.getRoleId();
    this.companyId = SessionStorageService.getCompanyId();
    this.joiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();

    this.state = {
      params: {}, // フォームの値を保持
    };
  }

  componentDidMount() {
    this.onLoad();
  }

  onLoad = async () => {
    const { data, result } = await fetchMg.GetAjax(
      `/api/private/user_profiles/${this.userId}`
    );

    if (result) {
      const { entities } = data;
      const params = {
        ...entities.user_profile,
        user_role_code: entities.role_code,
        partner_company_branch: entities.partner_company_branch,
      };
      let companyBranch = null;
      const companyBranches = entities.company_branch;
      const userType = _.pickBy(USER_ROLES, role => {
        return role.id == params.user_role_code;
      });

      // companyBranchsが0の時もあるので対処
      if (!_.isEmpty(companyBranches)) {
        companyBranch = companyBranches[0];
        params.department = companyBranch.department;
        params.company_branch_name = companyBranch.name;
        params.company_branch_id = companyBranch.id;
      }

      params.company = entities.company[0] || {};
      params.session = entities.session || {};
      params.image = entities.image || {};
      params.user_role_code_label = userType[Object.keys(userType)[0]].name;
      this.setState({ params, companyBranch });
    }
  };

  render() {
    const { params, companyBranch } = this.state;
    const imageURL = _.get(params, 'image.image_url', '');
    const getPartnerCompanyBranchName = () => {
      if (
        isTargetRoleId([USER_ROLES.partner, USER_ROLES.foreman], this.roleId) &&
        this.joiningFlag
      ) {
        return (
          <FormListItem label='支店'>
            <FormElement info='支店のデフォルトは本社となります。支店の登録、支店への配属は企業管理者のみが実行できます。'>
              <PreviewFormItemValue>
                {_.get(
                  params,
                  'partner_company_branch.name',
                  HEAD_OFFICE_OPTION.name
                )}
              </PreviewFormItemValue>
            </FormElement>
          </FormListItem>
        );
      }
    };

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.TITLE_NAME}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            dataTestId={'user-profile-detail'}
            title={this.TITLE_NAME}
            onClose={() => _masterSlideLoader.close()}
          />

          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <SideMenu roleId={this.roleId} />

              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <BackLinkButton />

                <FormViewMenu />

                <div className='contruction-detail-view__bar' />

                {/* ここからフォーム */}
                <div className='contruction-detail-view__main contruction-detail-view__main--fix contruction-detail-view__main--fixed'>
                  <FormList>
                    {/* 元請会社／協力会社(表示のみ) */}
                    {/* 所属元請会社／協力会社 */}
                    {isPartnerRoleId(this.roleId) && (
                      <UserFormElements.CompanyBaseDropdown
                        companyBranch={companyBranch}
                        disabled={true}
                      />
                    )}

                    {/* ログインユーザーが職長の場合のみ表示 */}
                    {/* 所属会社 */}
                    {isForemanRoleId(this.roleId) && (
                      <PreviewFormText
                        label='所属会社'
                        values={[_.get(params, 'company.name')]}
                      />
                    )}

                    {/* ログインユーザーが元請ユーザー(本社管理者以外)の場合のみ表示 */}
                    {isTargetRoleId(
                      [USER_ROLES.manager, USER_ROLES.branch],
                      this.roleId
                    ) && (
                      <PreviewFormText
                        label='支店'
                        values={[_.get(params, 'company_branch_name')]}
                      />
                    )}
                    {getPartnerCompanyBranchName()}
                    <PreviewFormText
                      label='ユーザー種別'
                      values={[params.user_role_code_label]}
                    />
                    {/* 姓 */}
                    <PreviewFormText label='姓' values={[params.name_sei]} />
                    {/* 名 */}
                    <PreviewFormText label='名' values={[params.name_mei]} />
                    {/* せい */}
                    <PreviewFormText label='せい' values={[params.kana_sei]} />
                    {/* めい */}
                    <PreviewFormText label='めい' values={[params.kana_mei]} />
                    {/* 電話番号 */}
                    <PreviewFormTel label='電話番号' values={[params.tel]} />

                    {/* ログインユーザーが協力会社管理者の時のみ表示 */}
                    {isPartnerRoleId(this.roleId) && (
                      <PreviewFormTel label='FAX番号' values={[params.fax]} />
                    )}

                    {/* ログインユーザーが元請ユーザー、または協力会社管理者の場合のみ表示される項目 */}
                    {(isPrimaryCompanyRoleId(this.roleId) ||
                      isPartnerRoleId(this.roleId) ||
                      params.integrated) && (
                      <PreviewFormText
                        label='ユーザーID（メールアドレス）'
                        values={[params.email]}
                      />
                    )}

                    {/* ログインユーザーが職長の場合のみ表示 */}
                    {isForemanRoleId(this.roleId) && !params.integrated && (
                      <PreviewFormText
                        label='ユーザーID'
                        values={[_.get(params, 'session.login_id')]}
                      />
                    )}

                    {/* ログインユーザーが職長の場合のみ表示 */}
                    {isForemanRoleId(this.roleId) && !params.integrated && (
                      <PreviewFormText
                        label='メールアドレス'
                        values={[params.email]}
                      />
                    )}

                    {/* 画像ファイルアイコン & アップロード */}
                    <PreviewFormImage
                      label='アイコン画像'
                      imgUrl={imageURL}
                      info={
                        isPrimaryCompanyRoleId(this.roleId)
                          ? 'こちらは顔認証で使用される画像ではありません。顔認証用の画像はサブメニューの「顔写真」から登録してください。'
                          : null
                      }
                    />
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SideMenu = ({ company_name, roleId }) => (
  <div className='contruction-detail-view__sidemenu'>
    <ul className='contruction-navi-list'>
      <li className='contruction-navi-list__item'>
        <a className='line-list line-list--contruction-navi-list select'>
          基本情報
        </a>
      </li>
      {isPrimaryCompanyRoleId(roleId) && (
        <li className='contruction-navi-list__item'>
          <a
            className='line-list line-list--contruction-navi-list'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              _masterSlideLoader.show('UserProfilePhoto', { state: {} });
            }}
          >
            顔写真
          </a>
        </li>
      )}
      <li className='contruction-navi-list__item'>
        <a
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileNotify', { state: {} });
          }}
        >
          通知設定
        </a>
      </li>
      <li className='contruction-navi-list__item'>
        <div
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileSettingMail', { state: {} });
          }}
        >
          メール受信設定
        </div>
      </li>
      <li className='contruction-navi-list__item' style={{ display: 'none' }}>
        <a className='line-list line-list--contruction-navi-list'>
          労務安全項目
        </a>
      </li>
      <li className='contruction-navi-list__item' style={{ display: 'none' }}>
        <a className='line-list line-list--contruction-navi-list'>
          {`${company_name || '名無し'} 独自項目`}
        </a>
      </li>
    </ul>
  </div>
);

const BackLinkButton = () => (
  <div className='contruction-detail-view__header'>
    <button className='btn-text--sm' onClick={() => _masterSlideLoader.close()}>
      <i className='i-back--blue i-2x vertical-middle' />
      閉じる
    </button>
  </div>
);

const FormViewMenu = () => (
  <div className='contruction-detail-view__menu'>
    <span className='construction-detail-view__button'>
      <button
        className='btn'
        onClick={() => {
          _masterSlideLoader.show('UserProfileForm', { state: { id: 1 } });
        }}
      >
        編集
      </button>
    </span>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/UserProfileDetail.jsx